;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { isViewWebsiteAsMemberOrLeaderVar } from "../reactiveVars"

// can only be [LEADER_ACTIVE_STATE, MEMBER_ACTIVE_STATE]
export default function updateIsViewWebsiteAsMemberOrLeader(value) {
  isViewWebsiteAsMemberOrLeaderVar(value)
}
